/*       */

import Immutable from 'app/utils/immutable/Immutable';

import { LOAD_RC_USER_LIST_STARTED, LOAD_RC_USER_LIST } from 'store/actions/chat/chatActions';

const initialState = {
    isUsersLoading: false,
    users: [],
};

export default (state = initialState, action) => {
    const { type, error, payload } = action;
    switch (type) {
        case LOAD_RC_USER_LIST_STARTED:
            return Immutable({ ...state, isUsersLoading: true });

        case LOAD_RC_USER_LIST: {
            if (error) {
                return Immutable({ ...state, isUsersLoading: false });
            }
            return Immutable({
                ...state,
                isUsersLoading: false,
                users: payload,
            });
        }

        default:
            return state;
    }
};
